import { GridComponent } from "@syncfusion/ej2-angular-grids";

export class CerListSelectionData {
    public page: number;
    public pageSize: number;
    public rowIndexOnPage: number;
}

export class CerListSelectionPager {

    public static rowIndexByDataGet(data: CerListSelectionData): number {
        return data?.rowIndexOnPage != null ?
            (data.page - 1) * data.pageSize + data.rowIndexOnPage :
            null;
    }

    public static resize(pageSizeNew: number, data: CerListSelectionData): CerListSelectionData {
        if (data.pageSize != pageSizeNew) {
            const idx = CerListSelectionPager.rowIndexByDataGet(data);
            const pageNew = idx != null ? Math.floor(idx / pageSizeNew) + 1 : null;
            const indexOnPageNew = idx != null ? idx - ((pageNew - 1) * pageSizeNew) : null;
            return idx != null ? { page: pageNew, pageSize: pageSizeNew, rowIndexOnPage: indexOnPageNew } : null;
        }
        return data;
    }

    public selection: CerListSelectionData;

    public clear() {
        this.selection = null;
    }

    public save(data: CerListSelectionData) {
        this.selection = data;
    }

    public restore(pageSizeCurrent: number): CerListSelectionData {
        this.selection = CerListSelectionPager.resize(pageSizeCurrent, this.selection);
        return this.selection;
    }
}

export type CerListSelectionResult = 'rowSelected' | 'pageSelected' | 'noSelection';

export class CerGridSelectionState {

    private pager: CerListSelectionPager = new CerListSelectionPager();

    constructor(private grid: GridComponent) { }

    public clear() {
        this.pager.clear();
    }

    public isEmpty() {
        const selection = this.pager?.selection;
        return (selection == null);
    }

    public save(rowIndexOnPage: number = null, pageNumber: number = null): boolean {
        const rowIdx: number = rowIndexOnPage ? rowIndexOnPage : this.rowSelectedRowIdxGet();
        if (rowIdx != null) {
            const data: CerListSelectionData = {
                page: pageNumber ? pageNumber : this.grid.pageSettings.currentPage,
                pageSize: this.grid.pageSettings.pageSize,
                rowIndexOnPage: rowIdx
            };
            this.pager.save(data);
            return true;
        }
        else {
           // this.pager.clear();
            return false;
        }
    }

    public saveFirstRowOnFirstPage() {
        this.save(0, 1);
        /*this.rowSelectedKeep(0);
        this.grid.scrollModule.refresh();
        if (this.grid.pageSettings.currentPage != 1) {
          this.grid.pageSettings.currentPage = 1;
        }*/
    }

    public saveRelative(rowIndexOnPage: number, relativeRowIdx: number = null): number {
        if (rowIndexOnPage !== undefined) {
            if (relativeRowIdx != null) {
                rowIndexOnPage = this.rowRelativeIdx(rowIndexOnPage, relativeRowIdx);
            }
            this.save(rowIndexOnPage);
            return rowIndexOnPage;
        }
        return null;
    }

    public restore(pageSize: number = null): CerListSelectionResult {
        if (this.pager?.selection) {
            const saved = Object.assign({}, this.pager?.selection);
            const current = this.pager.restore(pageSize ?? this.grid.pageSettings.pageSize);
            if (current) {
                if (current?.page && current.page != saved.page) {
                    this.grid.pageSettings.currentPage = current.page;
                    return 'pageSelected';
                }
                else if (this.rowSelectedRowIdxGet() != current.rowIndexOnPage) {
                    this.grid.selectRow(current.rowIndexOnPage);
                    return 'rowSelected';
                }
            }
        }
        return 'noSelection';
    }

    // Helper
    public rowSelectedRowIdxGet(): number {
        var idx: number = this.grid.selectedRowIndex;
        if (idx == -1) {
            idx = null;
        }
        return idx;
    }

    public rowRelativeIdx(idxOrig: number, relativeIdx: number): number {
        var idx = idxOrig;
        if (relativeIdx <= -1) {
            if (idx + relativeIdx >= 0) {
                idx += relativeIdx;
            }
            else {
                idx = 0;
            }
        }
        else if (relativeIdx >= 1) {
            if (idx + relativeIdx <= this.grid.getRows().length) {
                idx += relativeIdx;
            }
            else {
                idx = this.grid.getRows().length;
            }

        }
        return idx;
    }
}


